import { useValidatedSearchQuery } from "@hooks/use-validated-search-query";
import { isValidProjectSearchQuery } from "@utils/project-utils";

/** Custom hook to manage the projects search query */
export function useProjectsSearchQuery() {
  return useValidatedSearchQuery(isValidProjectSearchQuery);
}